import { useNavigate } from "react-router-dom";
import { useBillingCatalog } from "../core/billing-hooks";
import { PricingPlans } from "../features/billing/PricingPlans";

/** Public pricing page: the handoff plans screen fed by GET /billing/catalog
 *  (both sites, per-site catalog + presentation). Signed out every CTA routes
 *  to registration carrying the OPAQUE offer id, which the post-auth redirect
 *  hands to /billing for the real, server-authorized selection. */
export function PricingPage() {
  const navigate = useNavigate();
  const catalogQuery = useBillingCatalog();
  const catalog = catalogQuery.data?.catalog ?? null;
  return (
    <PricingPlans
      plans={catalog?.plans ?? []}
      snapshot={null}
      signedOut
      busy={false}
      error={catalogQuery.error}
      onSelect={(offer) => navigate(`/register?offer=${encodeURIComponent(offer.id)}`)}
    />
  );
}
